export default __webpack_public_path__ + "static/media/instagram.f50f1c1a.svg";